import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12" };
const _hoisted_2 = { class: "float-end" };
const _hoisted_3 = {
    key: 0,
    class: "col-xs-12 col-sm-12"
};
const _hoisted_4 = {
    class: "card bg-white data-grid report-schedule-grid detached overflow-x-auto",
    style: { "max-height": "calc(100vh - 250px)", "min-height": "300px" }
};
const _hoisted_5 = {
    id: "reportScheduleTable",
    class: "table table-hover bottom0 border-collapse-separate"
};
const _hoisted_6 = { class: "date-time-column" };
const _hoisted_7 = { class: "date-time-column" };
const _hoisted_8 = { class: "date-time-column" };
const _hoisted_9 = { class: "text-center" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_button = _resolveComponent("b-button");
    const _component_ReportSchedulerWizardVue = _resolveComponent("ReportSchedulerWizardVue");
    const _component_ReportScheduleedLogVue = _resolveComponent("ReportScheduleedLogVue");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.showModal) = $event)),
        "header-bg-variant": "normal",
        size: "xl"
    }, {
        title: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("\r\n\t\t\tReport Scheduler\r\n\t\t", -1 /* CACHED */)
            ]))]),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "secondary",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showModal = false))
                }, {
                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                            _createTextVNode(" Close\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        default: _withCtx(() => [
            _cache[35] || (_cache[35] = _createTextVNode()),
            _createVNode(_component_b_container, { clearfix: "" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_b_form_group, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_form_checkbox, {
                                        id: "includeDeleted",
                                        modelValue: _ctx.includeDeleted,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.includeDeleted) = $event))
                                    }, {
                                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]),
                    _cache[33] || (_cache[33] = _createTextVNode()),
                    (_ctx.loaded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("table", _hoisted_5, [
                                    _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _cache[6] || (_cache[6] = _createElementVNode("th", { class: "text-center w40 no-min-width" }, null, -1 /* CACHED */)),
                                            _cache[7] || (_cache[7] = _createTextVNode()),
                                            _createElementVNode("th", null, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'Description', title: 'Description' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]),
                                            _cache[8] || (_cache[8] = _createTextVNode()),
                                            _createElementVNode("th", null, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'ReportName', title: 'Report Name' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]),
                                            _cache[9] || (_cache[9] = _createTextVNode()),
                                            _createElementVNode("th", null, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'Period', title: 'Period' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]),
                                            _cache[10] || (_cache[10] = _createTextVNode()),
                                            _createElementVNode("th", _hoisted_6, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'Start', title: 'Start' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]),
                                            _cache[11] || (_cache[11] = _createTextVNode()),
                                            _createElementVNode("th", _hoisted_7, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'WhenCreated', title: 'When Created' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]),
                                            _cache[12] || (_cache[12] = _createTextVNode()),
                                            _createElementVNode("th", _hoisted_8, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'LastExecution', title: 'Last Execution' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ])
                                        ])
                                    ]),
                                    _cache[31] || (_cache[31] = _createTextVNode()),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (item) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                class: _normalizeClass({ 'deleted': item.whenDeleted })
                                            }, [
                                                _createElementVNode("td", _hoisted_9, [
                                                    _createVNode(_component_b_button_group, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown, {
                                                                variant: "outline-secondary dots",
                                                                size: "sm",
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.edit(item))
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                                                _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                                _createTextVNode(" Edit Schedule\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                            ]))]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["onClick"]),
                                                                    _cache[18] || (_cache[18] = _createTextVNode()),
                                                                    _createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.editFilters(item))
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                                _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                                _createTextVNode(" Edit Filters\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                            ]))]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["onClick"]),
                                                                    _cache[19] || (_cache[19] = _createTextVNode()),
                                                                    _createVNode(_component_b_dropdown_divider),
                                                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                                                    _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.archive(item))
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                                                _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                                _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                            ]))]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["onClick"]), [
                                                                        [_vShow, !item.whenDeleted]
                                                                    ]),
                                                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                                                    _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.restore(item))
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                                                _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                                _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                            ]))]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["onClick"]), [
                                                                        [_vShow, item.whenDeleted]
                                                                    ]),
                                                                    _cache[22] || (_cache[22] = _createTextVNode()),
                                                                    _createVNode(_component_b_dropdown_divider),
                                                                    _cache[23] || (_cache[23] = _createTextVNode()),
                                                                    _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.viewHistory(item))
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                                                _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* CACHED */),
                                                                                _createTextVNode(" View History\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                            ]))]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["onClick"]), [
                                                                        [_vShow, item.lastExecution]
                                                                    ])
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _cache[24] || (_cache[24] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(item.description), 1 /* TEXT */),
                                                _cache[25] || (_cache[25] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(item.reportName), 1 /* TEXT */),
                                                _cache[26] || (_cache[26] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.getPeriodDescription(item.period)), 1 /* TEXT */),
                                                _cache[27] || (_cache[27] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.getDateTime(item.start)), 1 /* TEXT */),
                                                _cache[28] || (_cache[28] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.getDateTime(item.whenCreated)), 1 /* TEXT */),
                                                _cache[29] || (_cache[29] = _createTextVNode()),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.getDateTime(item.lastExecution)), 1 /* TEXT */)
                                            ], 2 /* CLASS */));
                                        }), 256 /* UNKEYED_FRAGMENT */))
                                    ]),
                                    _cache[32] || (_cache[32] = _createTextVNode()),
                                    _createElementVNode("tfoot", null, [
                                        (_ctx.noData)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[30] || (_cache[30] = [
                                                    _createElementVNode("td", {
                                                        class: "text-center",
                                                        colspan: "7"
                                                    }, [
                                                        _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records.\r\n\t\t\t\t\t\t\t\t\t")
                                                    ], -1 /* CACHED */)
                                                ]))]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }),
            _cache[36] || (_cache[36] = _createTextVNode()),
            _cache[37] || (_cache[37] = _createTextVNode()),
            _createVNode(_component_ReportSchedulerWizardVue, {
                ref: "reportSchedulerWizard",
                onUpdateScheduleList: _ctx.getScheduledReports
            }, null, 8 /* PROPS */, ["onUpdateScheduleList"]),
            _cache[38] || (_cache[38] = _createTextVNode()),
            _createVNode(_component_ReportScheduleedLogVue, {
                modelValue: _ctx.showLog,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.showLog) = $event)),
                selectedModel: _ctx.selectedModel
            }, null, 8 /* PROPS */, ["modelValue", "selectedModel"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"]));
}
